import { MilkdownMarkdown } from "@thilke/ui/components/milkdown-markdown";

const sampleMarkdown = `# Ticket note

Render **markdown** with shared Thilke UI tokens, compact spacing, and stable Milkdown typography.

- Consistent paragraph size
- Tokenized links and code
- Editor mode available for wiki-style surfaces

\`@thilke/ui/components/milkdown-markdown\``;

export function MilkdownMarkdownDemo() {
  return (
    <div className="grid w-full max-w-3xl gap-4">
      <MilkdownMarkdown
        value={sampleMarkdown}
        variant="display"
        density="compact"
        ariaLabel="Readonly markdown preview"
      />
      <div className="rounded-md border border-line-subtle bg-card/75">
        <div className="border-b border-line-subtle px-3 py-2 text-xs text-muted-foreground">
          Editor mode
        </div>
        <MilkdownMarkdown
          value={sampleMarkdown}
          editing
          variant="editor"
          density="document"
          ariaLabel="Editable markdown preview"
        />
      </div>
    </div>
  );
}
